module.exports = __webpack_public_path__ + "ui/img/office365.2515acaf.svg";